import React from 'react'
import { Link } from 'react-router-dom'
import { Compass, ShieldCheck, Activity, Users, BarChart3, Network } from 'lucide-react'

export default function SolutionsHealthPlans() {
  return (
    <section className="section light" style={{ minHeight: '70vh' }}>
      <h2>Health Plans</h2>
      <p className="lead muted">
        Improve routing, strengthen continuity, and identify members at risk of disengagement before care
        breaks down — without replacing your existing provider directory or care management platform.
      </p>

      <div className="section-block">
        <div className="section-head"><h2>Why Health Plans Choose ATUUNE</h2></div>
        <div className="cards">
          <div className="card"><BarChart3 /><h3>Operational visibility</h3><p>See routing and continuity activity across your contracted provider network in one place.</p></div>
          <div className="card"><Compass /><h3>Routing intelligence</h3><p>Route members using structured intake data rather than availability alone.</p></div>
          <div className="card"><Activity /><h3>Continuity monitoring</h3><p>Identify members who may be drifting away from care before disengagement occurs.</p></div>
          <div className="card"><ShieldCheck /><h3>Early intervention</h3><p>Give provider organizations the lead time to reach out before a gap becomes a dropout.</p></div>
          <div className="card"><Users /><h3>Population insights</h3><p>Understand continuity patterns across your network, not just individual case status.</p></div>
          <div className="card"><Network /><h3>Supports existing provider networks</h3><p>Works underneath the network you've already credentialed and contracted — no network rebuild required.</p></div>
        </div>
      </div>

      <div className="actions" style={{ marginTop: 28 }}>
        <Link to="/contact">Request Demo</Link>
        <Link className="secondary outline-dark" to="/how-it-works">See How It Works</Link>
      </div>
    </section>
  )
}
